/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  A2PDeadlineStatus,
  CampaignRetryInput,
  RegistrationInput,
  RegistrationResult,
  RegistrationStatusResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getTelnyxA2pRegistration = () => {
  /**
   * Register a Telnyx 10DLC brand + campaign for the authenticated org.
   * @summary Register Endpoint
   */
  const telnyxA2pRegistrationRegisterEndpoint = (
    registrationInput: RegistrationInput,
    options?: SecondParameter<typeof axiosInstance<RegistrationResult>>
  ) => {
    return axiosInstance<RegistrationResult>(
      {
        url: `/admin/a2p/telnyx/register`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: registrationInput,
      },
      options
    );
  };
  /**
   * Get the current Telnyx A2P registration status for the authenticated org.
   * @summary Status Endpoint
   */
  const telnyxA2pRegistrationStatusEndpoint = (
    options?: SecondParameter<typeof axiosInstance<RegistrationStatusResponse>>
  ) => {
    return axiosInstance<RegistrationStatusResponse>(
      { url: `/admin/a2p/telnyx/status`, method: 'GET' },
      options
    );
  };
  /**
   * Retry campaign creation against an already-registered brand.
   * @summary Retry Campaign Endpoint
   */
  const telnyxA2pRegistrationRetryCampaignEndpoint = (
    campaignRetryInput: CampaignRetryInput,
    options?: SecondParameter<typeof axiosInstance<RegistrationResult>>
  ) => {
    return axiosInstance<RegistrationResult>(
      {
        url: `/admin/a2p/telnyx/retry-campaign`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: campaignRetryInput,
      },
      options
    );
  };
  /**
   * Start the 14-day SMS registration deadline for the authenticated org (support only).
   * @summary Start Deadline Endpoint
   */
  const telnyxA2pRegistrationStartDeadlineEndpoint = (
    options?: SecondParameter<typeof axiosInstance<A2PDeadlineStatus>>
  ) => {
    return axiosInstance<A2PDeadlineStatus>(
      { url: `/admin/a2p/telnyx/deadline/start`, method: 'POST' },
      options
    );
  };
  /**
   * Clear the SMS registration deadline for the authenticated org (support only).
   * @summary Clear Deadline Endpoint
   */
  const telnyxA2pRegistrationClearDeadlineEndpoint = (
    options?: SecondParameter<typeof axiosInstance<A2PDeadlineStatus>>
  ) => {
    return axiosInstance<A2PDeadlineStatus>(
      { url: `/admin/a2p/telnyx/deadline/clear`, method: 'POST' },
      options
    );
  };
  /**
   * Extend the SMS registration deadline for the authenticated org by 14 days (support only).
   * @summary Extend Deadline Endpoint
   */
  const telnyxA2pRegistrationExtendDeadlineEndpoint = (
    options?: SecondParameter<typeof axiosInstance<A2PDeadlineStatus>>
  ) => {
    return axiosInstance<A2PDeadlineStatus>(
      { url: `/admin/a2p/telnyx/deadline/extend`, method: 'POST' },
      options
    );
  };
  /**
   * Deadline state for the banner and add-candidate buttons. Makes no Telnyx calls.
   * @summary Deadline Status Endpoint
   */
  const telnyxA2pRegistrationDeadlineStatusEndpoint = (
    options?: SecondParameter<typeof axiosInstance<A2PDeadlineStatus>>
  ) => {
    return axiosInstance<A2PDeadlineStatus>(
      { url: `/a2p/deadline-status`, method: 'GET' },
      options
    );
  };
  return {
    telnyxA2pRegistrationRegisterEndpoint,
    telnyxA2pRegistrationStatusEndpoint,
    telnyxA2pRegistrationRetryCampaignEndpoint,
    telnyxA2pRegistrationStartDeadlineEndpoint,
    telnyxA2pRegistrationClearDeadlineEndpoint,
    telnyxA2pRegistrationExtendDeadlineEndpoint,
    telnyxA2pRegistrationDeadlineStatusEndpoint,
  };
};
export type TelnyxA2pRegistrationRegisterEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationRegisterEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationStatusEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationStatusEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationRetryCampaignEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationRetryCampaignEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationStartDeadlineEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationStartDeadlineEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationClearDeadlineEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationClearDeadlineEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationExtendDeadlineEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationExtendDeadlineEndpoint']
    >
  >
>;
export type TelnyxA2pRegistrationDeadlineStatusEndpointResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getTelnyxA2pRegistration
      >['telnyxA2pRegistrationDeadlineStatusEndpoint']
    >
  >
>;
